import { ReactNode } from "react";
import { atom } from "recoil";

export type Info = {
  modalState: "open" | "close";
  infoMessage?: string;
  subMessage?: ReactNode | string;
  onClose?: () => void | Promise<void>;
};

export type Notification = {
  modalState: "open" | "close";
  notificationMessage?: string;
  isHiddenWarningIcon?: boolean;
  subMessage?: ReactNode | string;
  positiveButtonText?: string;
  // HACK: Notificationが汎用的に使われているため、any型を利用
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  positiveAction?: (arg?: any) => void | Promise<void>;
  cancelAction?: () => void | Promise<void>;
};

export type Confirm = {
  modalState: "open" | "close";
  confirmMessage?: ReactNode;
  subMessage?: ReactNode | string;
  positiveButtonText?: string;
  positiveAction?: () => void | Promise<void>;
  cancelAction?: () => void | Promise<void>;
  top?: string;
};

export type Error = {
  modalState: "open" | "close";
  errorMessage?: string;
  subMessage?: ReactNode | string;
  attentionMessage?: ReactNode | string;
  buttonText?: string | ReactNode;
  onClose?: () => void | Promise<void>;
};

export type ModalStore = {
  info?: Info;
  notification?: Notification;
  confirm?: Confirm;
  dynamicHeightConfirm?: Confirm;
  error?: Error;
};

export const modalStore = atom<ModalStore>({
  key: "modal",
  default: {
    info: { modalState: "close" },
    confirm: { modalState: "close" },
    dynamicHeightConfirm: { modalState: "close" },
    notification: { modalState: "close" },
    error: { modalState: "close" },
  },
});
